import { render, staticRenderFns } from "./Tanya-Pateron.vue?vue&type=template&id=e1d393d4&"
import script from "./Tanya-Pateron.vue?vue&type=script&lang=js&"
export * from "./Tanya-Pateron.vue?vue&type=script&lang=js&"
import style0 from "./Tanya-Pateron.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports